import { supabase } from './client';

export interface JobSubscription {
  id: string;
  user_id: string;
  keywords: string[];
  location: string;
  is_active: boolean;
  auto_submit_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export async function getUserSubscriptions(userId: string) {
  const { data, error } = await supabase
    .from('job_subscriptions')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data as JobSubscription[];
}

export async function createJobSubscription(
  userId: string,
  keywords: string[],
  location: string
) {
  const { data, error } = await supabase
    .from('job_subscriptions')
    .insert({
      user_id: userId,
      keywords,
      location,
      is_active: true,
    })
    .select()
    .single();

  if (error) throw error;
  return data as JobSubscription;
}

export async function updateJobSubscription(
  subscriptionId: string,
  updates: { keywords?: string[]; location?: string; is_active?: boolean; auto_submit_enabled?: boolean }
) {
  const { data, error } = await supabase
    .from('job_subscriptions')
    .update(updates)
    .eq('id', subscriptionId)
    .select()
    .single();

  if (error) throw error;
  return data as JobSubscription;
}

export async function deleteJobSubscription(subscriptionId: string) {
  const { error } = await supabase
    .from('job_subscriptions')
    .delete()
    .eq('id', subscriptionId);

  if (error) throw error;
}

export async function toggleSubscription(subscriptionId: string, isActive: boolean) {
  return updateJobSubscription(subscriptionId, { is_active: isActive });
}
